import React from "react";

import { Link } from "react-router-dom";

import { ContentUploadResumeProps } from "./models";

import {
    Box,
    Button,
    Grid,
    Stack,
    Typography
} from "@mui/material";
import { Trans } from "@lingui/macro";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/Check";

export default class ContentUploadResume extends React.Component<ContentUploadResumeProps, {}> {

    render() {
        return (<Box
            p={2}
            borderRadius="5px"
            bgcolor={process.env.REACT_APP_THIRD_COLOR}>
                {this.props.error && <Stack alignItems="center" p={4}>
                    <SentimentVeryDissatisfiedIcon color="error" sx={{ fontSize: 150 }} />
                    <Typography variant="h2" mb={6} sx={{ color: "white"}}>
                        <Trans id="cur-error"> Si è verificato un errore nel
                            caricamento del contenuto</Trans>
                    </Typography>
                    <Link to="/backoffice/content-upload">
                        <Button variant="contained" startIcon={<ArrowBackIcon />}>
                            <Trans id="cur-retry"> Riprova</Trans>
                        </Button>
                    </Link>
                </Stack>}
            {!this.props.error && <Stack alignItems="center" p={4}>
                <SentimentVeryDissatisfiedIcon sx={{ fontSize: 150, color: "white" }} />
                <Typography variant="h2" sx={{ color: "white" }}>
                    <Trans id="cur-success">Caricamento avvenuto con
                        successo</Trans>
                </Typography>
                <Grid container rowSpacing={2} mt={6}>
                    <Grid item sm={12} textAlign={"center"}>
                        <Link to="/backoffice/content-upload" style={{ textDecoration: "none" }}>
                            <Button variant="contained" startIcon={<ArrowBackIcon />}
                                onClick={() => this.props.backToContentUpload()}>
                                <Trans id="cur-upload-other" comment="Back text on buttons"> Carica altro </Trans>
                            </Button>
                        </Link>
                    </Grid>
                    <Grid item sm={12} textAlign={"center"}>
                        <Link to="/backoffice/manage-content" style={{ textDecoration: "none" }}>
                            <Button variant="contained" startIcon={<ArrowBackIcon />}>
                                <Trans id="cur-to-list" comment="Back text on buttons"> Vai alla lista contenuti</Trans>
                            </Button>
                        </Link>
                    </Grid>
                </Grid>
            </Stack>}
        </Box>);
    }
}
